import Image from 'next/image';
import Container from '@/components/layout/Container';

export default function CenterTextBanner({ block, position }) {
  const {
    title,
    description,
    text_color,
    background_color,
    description_text_style,
    logos,
    _metadata
  } = block.center_text;

  // Define the description style based on condition
  const descriptionClass =
    description_text_style === 'Small' ? 'body-r sm:body-l' : 'h5 lg:h3';

  // Render logos
  const renderLogos = (logos) =>
    logos.map((item, index) => (
      <div key={index}>
        <Image
          src={item.logo.url}
          width="240"
          height="96"
          sizes="(min-width: 1536px) 240px, (min-width: 1024px) 142px, 142px"
          alt={item.logo.title.replace(/\.[^/.]+$/, '')}
          className="max-h-[56px] min-h-[56px] w-full lg:max-h-[96px] lg:min-h-[96px]"
        />
      </div>
    ));

  return (
    <section
      id={`${_metadata.uid}_${position}`}
      data-name="banner-center-text"
      className={`banner-center-text py-[80px] lg:py-[120px] ${background_color ? `bg-[${background_color}]` : ''}`}
    >
      <Container>
        <div
          className={`mx-auto max-w-[1080px] px-1 text-center sm:px-5 ${text_color ? `text-[${text_color}]` : ''}`}
        >
          {title && <h2 className="h3 lg:h2 mb-4">{title}</h2>}
          {description && <p className={descriptionClass}>{description}</p>}
        </div>
        {logos?.length > 0 && (
          <div className="mx-auto grid w-full grid-cols-2 gap-y-10 pt-10 sm:flex sm:justify-between sm:px-5 sm:pt-15 lg:px-0">
            {renderLogos(logos)}
          </div>
        )}
      </Container>
    </section>
  );
}
